import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';

@Component({
  selector: 'app-search-pagination',
  templateUrl: './search-pagination.component.html',
  styleUrls: ['./search-pagination.component.scss']
})
export class SearchPaginationComponent {
  @Input() searchForm!: FormControl;
  @Input() itemCount = 0;
  @Input() selectedItemsCount = 0;
  @Input() label = 'items';
  @Output() searchChanged = new EventEmitter<string>();
  @Output() pageChanged = new EventEmitter<any>();
  @ViewChild(PaginatorComponent) paginator!: PaginatorComponent;

  onSearchChange(value: string): void {
    this.searchChanged.emit(value);
  }

  onPageEvent(event: any): void {
    this.pageChanged.emit(event);
  }

  resetPagination(): void {
    this.paginator?.resetFirstPage();
  }
}
